import { useHotkeys } from "react-hotkeys-hook";
import useEditorStore from "../../stores/useEditorStore";
import useWorkflowStore from "../../stores/useWorkflowStore";
import { useShallow } from "zustand/shallow";
import { isActiveDesignWorkflow } from "../../constants/flowConfig";
import { useState } from "react";

export function DesignShortcuts()
{
    const [ undo, redo, toggleUnmodifiedMesh, toggleWireframe, toggleGhostMode, toggleColorMode, toggleNormalMode ] = useEditorStore(
        useShallow(
            (state) => [
                state.undo, state.redo, state.toggleUnmodifiedMesh, state.toggleWireframe, state.toggleGhostMode, state.toggleColorMode, state.toggleNormalMode
            ]
        )
    );

    const [ currentWorkflow ] = useWorkflowStore(
        useShallow(
            (state) => [
                state.currentWorkflow
            ]
        )
    );

    const isEditor = isActiveDesignWorkflow(currentWorkflow);

    useHotkeys('ctrl+z, cmd+z', undo, {enabled: isEditor});
    useHotkeys('ctrl+y, cmd+y', redo, {enabled: isEditor});
    useHotkeys('shift+a', toggleUnmodifiedMesh, {enabled: isEditor});
    useHotkeys('w', toggleWireframe, {enabled: isEditor});
    useHotkeys('g', toggleGhostMode, {enabled: isEditor});
    useHotkeys('d', toggleColorMode, {enabled: isEditor});
    useHotkeys('shift+n', toggleNormalMode, {enabled: isEditor});

    return null;
}